import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.instrumentation'),
    id: 'vitrolink',
    sidebar: [
        {
            id: 'devices',
            label: i18n.tc('configuration.grid.device', 2),
            icon: 'icon-instrument',
            routeName: 'Devices',
            hasChildren: false
        }
    ]
}
